import { collections } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function CollectionIndex() {
  return (
    <section id="heji" className="scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="目录式检索归档"
          title="合集索引 · 按主题装订成册"
          desc="不按时间堆料，而是按题材把散落的瓜归档成册。想看「人物」去档案室，想追「综艺」去名场面，一站式检索，少走弯路。"
          action="进入全部合集"
          align="center"
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 md:mt-12 lg:grid-cols-3">
          {collections.map((c, i) => (
            <a
              key={c.title}
              href="#"
              className="group relative block overflow-hidden rounded-xl"
            >
              <img
                src={c.image}
                alt={c.title}
                title={`${c.title} - 嘿料吃瓜合集索引`}
                className="h-80 w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05] md:h-[420px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
              <span className="absolute right-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-black text-foreground-950">
                {c.accent}
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 p-5 md:p-6">
                <div>
                  <h3 className="font-heading text-lg font-black leading-snug text-white md:text-xl">{c.title}</h3>
                  <p className="mt-1 text-xs text-white/70 md:text-sm">{c.subtitle}</p>
                  <p className="mt-3 inline-flex items-center gap-2 text-xs font-bold text-accent-300">
                    收录 {c.count} 篇精选
                    <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </p>
                </div>
                <span className="hidden font-display text-5xl font-black text-white/15 md:block">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}